import React, {useEffect, useMemo, useState} from 'react'
import {useSearchParams} from 'react-router-dom'
import {useQuery} from 'react-query'
import {getAll} from '../../../services/common_requests'
import {useQueryResponse, ResponseData} from './core/QueryResponseProvider'
import {useQueryRequest} from './core/QueryRequestProvider'
import {buildUserApiQuery} from './core/userListQuery'
import {UserDetailsModal} from './user-details-modal/UserDetailsModal'
import {UserFormModal} from './user-form-modal/UserFormModal'
import {useListView} from './core/ListViewProvider'
import {KTCard} from '../../../../_dashboard/helpers'
import {UsersTable} from './table/UsersTable'
import {UsersListHeader} from './header/UsersListHeader'

const UsersList: React.FC = () => {
  const {itemIdForUpdate, viewUserId, setViewUserId} = useListView()
  const [searchParams, setSearchParams] = useSearchParams()
  const {updateState} = useQueryResponse()
  const {state: queryState} = useQueryRequest()
  const [filters, setFilters] = useState({
    page: 0,
    size: 10,
    status: '' as string,
    role: '' as string,
  })

  useEffect(() => {
    const viewId = searchParams.get('view')
    if (viewId) {
      setViewUserId(viewId)
      const next = new URLSearchParams(searchParams)
      next.delete('view')
      setSearchParams(next, {replace: true})
    }
  }, [searchParams, setSearchParams, setViewUserId])

  const queryParams = useMemo(
    () =>
      buildUserApiQuery(queryState, {
        page: filters.page,
        size: filters.size,
        listScope: 'team',
        ...(queryState.search ? {searchUser: queryState.search} : {}),
        ...(filters.status ? {status: filters.status} : {}),
        ...(filters.role ? {role: filters.role} : {}),
      }),
    [filters.page, filters.size, filters.status, filters.role, queryState],
  )

  useQuery<ResponseData>(
    ['users', queryParams],
    () => getAll(queryParams, '/users'),
    {
      onSuccess: (data) => {
        updateState(data)
      },
    },
  )

  return (
    <>
      <KTCard>
        <UsersListHeader filters={filters} setFilters={setFilters} />
        <UsersTable setFilters={setFilters} />
      </KTCard>
      {viewUserId && <UserDetailsModal />}
      {itemIdForUpdate && <UserFormModal />}
    </>
  )
}

export {UsersList}
